import { useIsMobile } from '@noor/lib';
import type { ModalRenderProps } from '@noor/lib';
import { UserFormModalDesktop } from './user-form-modal.desktop';
import { UserFormSheetMobile } from './user-form-sheet.mobile';

type UserFormModalProps = ModalRenderProps<'add-user'> | ModalRenderProps<'edit-user'>;

/**
 * Create / edit employee. Picks the mobile full-screen sheet (Figma
 * 26295:98779 / 26295:98930) or the desktop dialog.
 *
 * The registry binds ONE component per modal id, so this picker keeps
 * `add-user`/`edit-user` a single name — `openModal('edit-user', …)` resolves
 * to a sheet or a dialog without the caller, or the registry, knowing there
 * are two (CLAUDE.md §6c).
 */
export function UserFormModal(props: UserFormModalProps) {
  return useIsMobile() ? (
    <UserFormSheetMobile {...props} />
  ) : (
    <UserFormModalDesktop {...props} />
  );
}
